<script>
import {Graylog} from '../graylog'
import SearchOptions from './SearchOptions.vue'
import PerformanceDashboard from './PerformanceDashboard.vue'


export default {
  name: 'Dashboard',
  components: {
    SearchOptions,
    PerformanceDashboard
  },

  watch: {
    searchParams: {
      deep: true,
      handler() {
        this.fetchDeployments()
        localStorage.setItem('searchParams', JSON.stringify(this.searchParams));
      }
    }
  },

  methods: {
    fetchDeployments() {
      this.deployments = []
      if (this.deploymentTimeout) {
        clearTimeout(this.deploymentTimeout)
      }
      this.deploymentTimeout = setTimeout(()=>{
        Graylog.getDeployments(this.searchParams).then(response => {
          this.deployments = response.data.messages.map(item => item.message)
        });
        this.deploymentTimeout = null
      }, 500)
    }
  },

  data() {
    return {
      deployments: [],

      histogrammData: null,

      // default search params
      searchParams: {
        facility: 'fleetbutler production',
        range: 12*60*60,
        interval: 'day'
      }
    }
  },

  mounted() {
    let savedParams = localStorage.getItem('searchParams');
    if (savedParams) {
      this.searchParams = JSON.parse(savedParams);
    }
  }

}
</script>

<template>
  <div>

    <SearchOptions :searchParams="searchParams"/>
    <hr>

    <PerformanceDashboard :searchParams="searchParams"
        cacheKey="requests"
        durationField="time"
        basicQuery="_exists_:path"
        :title="'Requests between {{minimumDuration}} - {{maximumDuration}} seconds'"
        :deployments="deployments"
        :pieCharts="[
          { field: 'agent', label: 'User-Agents' },
          { field: 'user', label: 'Affected Users' },
          { field: 'path', label: 'Path' },
          { field: 'role', label: 'Role' }
        ]">
    </PerformanceDashboard>
    <hr>

    <PerformanceDashboard :searchParams="searchParams"
        cacheKey="requests_memory_after_mb"
        durationField="memory_after_mb"
        chartTitle="Process Memory"
        basicQuery="_exists_:memory_after_mb"
        groupingAggregation="max"
        :showGraylogLink="false"
        :showTotalCounts="false"
        :title="'Process Memory for Requests between {{minimumDuration}} - {{maximumDuration}} seconds'"
        :deployments="deployments"
        :pieCharts="[
          { field: 'source', label: 'Source' }
        ]">
    </PerformanceDashboard>
    <hr>

    <PerformanceDashboard :searchParams="searchParams"
        cacheKey="requests_sql_queries"
        durationField="sql_queries"
        chartTitle="SQL Queries"
        basicQuery="_exists_:sql_queries"
        :title="'SQL Queries for Requests between {{minimumDuration}} - {{maximumDuration}} seconds'"
        :deployments="deployments"
        :pieCharts="[
          { field: 'agent', label: 'User-Agents' },
          { field: 'user', label: 'Affected Users' },
          { field: 'path', label: 'Path' },
          { field: 'role', label: 'Role' }
        ]">
    </PerformanceDashboard>
    <hr>

    <PerformanceDashboard :searchParams="searchParams"
        cacheKey="slow-queries"
        durationField="duration"
        basicQuery="SLOW QUERY"
        :title="'SQL Queries between {{minimumDuration}} - {{maximumDuration}} seconds'"
        :deployments="deployments"
        :pieCharts="[
          { field: 'backtrace_md5', label: 'Backtrace MD5' },
          { field: 'location', label: 'Location' },
          { field: 'url', label: 'URL' }
        ]">
    </PerformanceDashboard>
    <hr>

    <PerformanceDashboard :searchParams="searchParams"
        cacheKey="active-job"
        facilityPrefix="SIDEKIQ - "
        durationField="runtime"
        basicQuery='worker:"ActiveJob::QueueAdapters::SidekiqAdapter::JobWrapper" AND _exists_:runtime'
        :title="'[ActiveJob] Jobs between {{minimumDuration}} - {{maximumDuration}} seconds'"
        :deployments="deployments"
        :pieCharts="[
          { field: 'job_class', label: 'Job' },
          { field: 'active_job_record', label: 'Record' },
          { field: 'queue', label: 'Queue' }
        ]">
    </PerformanceDashboard>
    <hr>

    <PerformanceDashboard :searchParams="searchParams"
        cacheKey="sidekiq"
        facilityPrefix="SIDEKIQ - "
        durationField="runtime"
        basicQuery='_exists_:worker AND NOT(worker:"ActiveJob::QueueAdapters::SidekiqAdapter::JobWrapper") AND _exists_:runtime'
        :title="'[Sidekiq] Jobs between {{minimumDuration}} - {{maximumDuration}} seconds'"
        :deployments="deployments"
        :pieCharts="[
          { field: 'worker', label: 'Job' },
          { field: 'active_job_record', label: 'Record' },
          { field: 'queue', label: 'Queue' }
        ]">
    </PerformanceDashboard>
    <hr>

  </div>
</template>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
hr {
  max-width: 100%;
}
</style>
